const CHATS_URL = '/_exclusive/helps/chats';

/**
 * Attempt to create new GPT session
 * The API would return the currently active session if any
 * https://blueprint.bukalapak.io/exclusive/t/helps~help~chats~post~exclusive~helps~chats
 * @param {import('@nuxtjs/axios').NuxtAxiosInstance} $axios
 * @returns {Promise}
 */
export const createSession = $axios => $axios.$post(`${CHATS_URL}`);

/**
 * Get the current session data and its chat log
 * https://blueprint.bukalapak.io/exclusive/t/helps~help~chats~get~exclusive~helps~chats~session~id
 * @param {import('@nuxtjs/axios').NuxtAxiosInstance} $axios
 * @param {object} payload
 * @param {string} payload.sessionId
 * @param {object} payload.etag
 * @returns {Promise}
 */
export const getCurrentSession = ($axios, { sessionId = '', etag = '' }) => {
  const headers = etag ? { 'If-None-Match': etag } : {};
  return $axios.get(`${CHATS_URL}/${sessionId}`, { headers });
};

/**
 * Send message into the current GPT session
 * https://blueprint.bukalapak.io/exclusive/t/helps~help~chats~post~exclusive~helps~chats~session~id~messages
 * @param {import('@nuxtjs/axios').NuxtAxiosInstance} $axios
 * @param {object} payload
 * @param {string} payload.sessionId
 * @param {string} payload.content - text message
 * @param {string} payload.attachment - base64 string of an attachment
 * @param {object | null} payload.context - any form of object, typically used for handling transaction complaint
 * @returns {Promise}
 */
export const sendMessageOrAttachment = ($axios, { sessionId = '', content = '', attachment = '', context = null }) =>
  $axios.$post(`${CHATS_URL}/${sessionId}/messages`, {
    message: {
      content,
      attachment,
      context,
    },
  });

/**
 * Update the current session's status. *only supports closing session for now
 * https://blueprint.bukalapak.io/exclusive/t/helps~help~chats~patch~exclusive~helps~chats~session~id~status
 * @param {import('@nuxtjs/axios').NuxtAxiosInstance} $axios
 * @param {object} payload
 * @param {string} payload.sessionId
 * @param {string} payload.state - 'closed' | ...
 * @returns {Promise}
 */
export const updateCurrentSessionStatus = ($axios, { sessionId = '', state = '' }) => {
  return $axios.$patch(`${CHATS_URL}/${sessionId}/status`, { state });
};
